import React, { useState } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import { FaGlobe } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCavpAsv = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);

  let [openModal, setOpenModal] = useState(false);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };
  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Cavp" && Carriere.ParamCotisations.BiologisteConventionne === "oui").length > 0 && (
        <tr>
          <td>PCV CAVP</td>
          <td
            onClick={() => {
              setOpenModal(true);
            }}
          >
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp}
              style={{ backgroundColor: "white" }}
              disabled
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCavpSupp}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "AnneeFinCavpSupp", e);
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Cavp?.General?.AsvPointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Cavp?.General?.AsvPointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
      )}

      <Modal
        width="30%"
        height="60%"
        title=" POINTS PCV CAVP"
        icon={<FaGlobe />}
        visible={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1977 et 1981"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp19771981}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp19771981")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1982 et 1986"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp19821986}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp19821986")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1987 et 1991"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp19871991}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp19871991")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1992 et 1996"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp19921996}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp19921996")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 1997 et 2001"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp19972001}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp19972001")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label="Entre 2002 et 2005"
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavp20022005}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavp20022005")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column>
                          <TextField
                            label={"Entre 2006 et "+context.state.TableauPoints.AnneeFinCavpSupp}
                            value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCavpApres2006}
                            onChange={context.handleModalPoint(ClientConjoint, "RetraiteSuppCavpApres2006")}
                            dataType="ufloat"
                            format={{ thousands: " ", precision: 2, decimal: "," }}
                            normal
                          />
                        </Column>
                      </Row>
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setOpenModal(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};
export default PointCavpAsv;
